export const WHatsDoneConfig = {
    name            : 'What\'s done',
    icon            : 'i5-whats-done',
    image           : 'whats-done',
    iconSvg         : 'isvg-view-whats-done',
    url             :  'what-is-done',
    description     : 'Full report on completed tasks, projects, and achieved milestones for a selected time period.',
    canBeInProject  : true,
}

export const CUSTOM_VIEW_WHATS_DONE_CONFIG = {
    ...WHatsDoneConfig,
    // key2: "newValue2",  // Replacing the value for key2
}